import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { loanManagementUrl } from "../../../../config";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../../theme";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
const base_url = loanManagementUrl.uri;

const ignoreFields = [
  "Installments",
  "Installmentamount",
  "Applicationdate",
  "Isloanapproved",
  "Interestamount",
  "Isloancleared",
  "Loandisbursedate",
  "Loanapprovaldate",
  "Arrearsoverduedays",
  "Isinarrears",
  "Rolledover",
  "Expectedcleardate",
  "Interestamount",
  "Arrearsoverduedays",
  "Principlearrears",
  "Interestarrears",
  "Isnonperforming",
  "Rolloverpenalty",
  "Iswrittenoff",
  "Loandeclineid",
  "Isloandeclined",
  "Loandeclinedreason",
  "Writtenoffdate",
  "Rolloverdate",
  "Branchcomments",
  "Iscompanyapproved",
  "Isrescheduled",
  "Accountid",
  "Isrebooked",
  "Channelid",
  "Branchid",
  "Regionid",
  "Companyid",
  "Migratedby",
  "Datecreated",
  "Createdby",
  "Updateddate",
  "Updatedby",
  "Verifiedby",
  "Verifieddate",
  "Name",
  "Loancleareddate",
  "Serviceloans",
  "Penaltyapprovalcomments",
  "Penaltyapprovaldate",
  "Penaltyaddedby",
  "Penaltyapprovedby",
  "Penaltyrejectedby",
  "Servicedloans",
  "Productname",
  "Penaltyamountaddeddate",
  "Penaltyrejectioncomments",
];


const actions = {
  entity: "Approve Penalty (Customer)",
  approvePenalty: {
    key: "approveloanpenalty",
    button_name: "Approve",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4, 5],
    modelName: "penaltyApproval", // Specify the model name here
    inputObjectName: "approvePenalty",
    approve:true,
    isgroup:0
  },
  rejectPenalty: {
    key: "approveloanpenalty",
    button_name: "Reject",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4, 5],
    modelName: "penaltyApproval", // Specify the model name here
    inputObjectName: "approvePenalty",
    approve:false,
    isgroup:0
  },

  dataObject: {
    ignoreFields,
    objectName: "allPenaltyApprovalLoanapplication",
    parameters: "",
  },
  showMore: {
    objectname: "penaltyApprovalViewLoansByColumnValues",
    inputsubobjectname: "application",
    parameters: "id",
    search: true,
    min: 3,
    max: 10,
    otherParams: 1,
    isCustomer: false,
  },
};
function ApproveCustomerPenaltyLoan() {
  // const [dialogOpen, setDialogOpen] = useState(false);

  // const theme = useTheme();
  // const colors = tokens(theme.palette.mode);
  // const handleOpenModal = () => {
  //   setDialogOpen(true);
  // };

  return (
    <Box m="2px">
      <DynamicTableForJson
        title="Customer Loan Penalty Approval"
        subtitle="View all Loans, Approve Penalty"
        // FormComponent={LoanGroupPenaltyApplicationForm}
        // columns={columns}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default ApproveCustomerPenaltyLoan;
